import RatedArticles from "./RatedArticles";

const UserFavoritePage = () => {
  return (
    <div className="Page">
      <div className="Page-Content">
        <RatedArticles type="favorite" title="Omiljeni artikli" />
      </div>
    </div>
  );
};
export default UserFavoritePage;
